import { entryFactory } from 'factories/entry';
import { postCodeFactory } from 'factories/post-code';
import { priceFactory } from 'factories/price';
import { OptionCollect, ReturnDetails } from 'types';
import { convertTimestampToDate } from 'helpers';

function populateEntries(entries: any = []) {
  return entries.map((entryData: any) => {
    const {
      entry,
      action,
      expectedQuantity,
      reason,
      status,
      additionalReason,
      additionalInformation,
    } = entryData;

    return {
      entry: entryFactory(entry),
      action: action ?? '',
      expectedQuantity: expectedQuantity ?? 0,
      reason: reason ?? '',
      status: status ?? '',
      additionalReason: additionalReason ?? '',
      additionalInformation: additionalInformation ?? '',
    };
  });
}

function populateOption(optionData: any = {}): OptionCollect {
  const { code, title, type } = optionData;

  return {
    code: code || '',
    title: title || '',
    type: type || '',
  };
}

export function returnDetailsFactory(data: any = {}): ReturnDetails {
  const {
    consignmentCode,
    entries,
    isChargedback,
    option,
    protocol,
    status,
    postOffice,
    cancelDescription,
    refundPrice,
    refundedDate,
    exchangeChannel,
  } = data;

  return {
    consignmentCode: consignmentCode || '',
    entries: populateEntries(entries),
    isChargedback: isChargedback || false,
    option: populateOption(option),
    protocol: protocol || '',
    status: status || '',
    postOffice: postCodeFactory(postOffice),
    cancelDescription: cancelDescription || '',
    refundedDate: convertTimestampToDate(refundedDate || 0),
    refundPrice: priceFactory(refundPrice),
    exchangeChannel: exchangeChannel || '',
  };
}
